<template>
  <v-app class='app' :class="{is_full: isFull}">
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>

export default {
  name: 'App',

  components: {
  },

  data: () => ({
    isFull: false,
  }),

  mounted() {
    document.oncontextmenu = () => false;
  },

  watch: {
    $route() {
      this.isFull = false;
      if (window.location.href.indexOf('gacha-animation') > 0) {
        this.isFull = true;
      }
      window.scrollTo(0, 0);
    },
  },
};
</script>

<style lang="scss" scoped>
.v-application--wrap {
  min-height: auto!important;
}
</style>

<style lang="scss">
html, body {
  font-family: $notoSansJP;
}
.v-application {
  font-family: $notoSansJP!important;
}
.app {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  &.is_full {
    max-width: 100%;
  }
}
</style>
